import {Style, Icon} from 'ol/style';
import xml2js from 'xml2js';

import { parser as gradientCssParser } from '../../utils/Gradient/parser.js';
import { applicator as gradientSvgApplicator } from '../../utils/Gradient/svg.js';

// symbol svg declaration shape

import svg_marker1 from "bundle-text:./assets/SVG/marker1.svg"
import svg_marker1_plain from "bundle-text:./assets/SVG/marker1.plain.svg"
import svg_marker2 from "bundle-text:./assets/SVG/marker2.svg"
import svg_marker2_plain from "bundle-text:./assets/SVG/marker2.plain.svg"
import svg_marker3 from "bundle-text:./assets/SVG/marker3.svg"
import svg_marker3_plain from "bundle-text:./assets/SVG/marker3.plain.svg"
import svg_comment from "bundle-text:./assets/SVG/comment.svg"
import svg_comment_plain from "bundle-text:./assets/SVG/comment.plain.svg"

const symboles = {
	default: {
		svg:svg_marker1,
		center:[0.5,0.36], // point centrale pour la superposition correcte d'élément
	},
	marker1: {
		svg:svg_marker1,
		center:[0.5,0.36],
	},
	marker1_plain: {
		svg:svg_marker1_plain,
		center:[0.5,0.36],
	},
	marker2: {
		svg:svg_marker2,
		center:[0.5,0.395],
	},
	marker2_plain: {
		svg:svg_marker2_plain,
		center:[0.5,0.395],
	},
	marker3: {
		svg:svg_marker3,
		center:[0.5,0.425],
	},
	marker3_plain: {
		svg:svg_marker3_plain,
		center:[0.5,0.425],
	},
	comment: {
		svg:svg_comment,
		center:[0.5,0.425],
	},
	comment_plain: {
		svg:svg_comment_plain,
		center:[0.5,0.425],
	},
}

export const Symbole = async (styleDef,layer,__style) => {

	const ratio = layer.ratio || 1;
	const iconSize = styleDef.size * ratio;

	const _symbole = layer.symbole && symboles[layer.symbole] ? symboles[layer.symbole] : symboles['default'];

	var icon = _symbole.svg;

	if(icon)
	{
		icon = await xml2js.parseStringPromise(icon);
		icon.svg.$.width = iconSize+'px';
		icon.svg.$.height = iconSize+'px';

		var builder = new xml2js.Builder();
		icon = builder.buildObject(icon);

		if(!layer.fill && layer.color)
			layer.fill = '#fff';

		if(layer.fill)
		{
			const gradient = gradientCssParser(layer.fill);
			if(gradient)
			{
				icon = gradientSvgApplicator(gradient,icon);
				layer.fill = null; // prevent open layer colorization behaviour
			}
			else
			{
				if(icon.indexOf('fill=')>=0)
				{
					icon = icon.replaceAll(/fill="[^"]+"/g,`fill="${layer.fill}"`);
				}
				else
				{
					icon = icon.replace(/(<svg[^>]+)>/,`$1><g fill="${layer.fill}">`);
					icon = icon.replace('</svg>',`</g></svg>`);
				}
			}
		}

		if(layer.stroke)
		{
			icon = icon.replace(/(<svg[^>]+)>/,`$1>
				<g stroke="${layer.stroke.color}" stroke-width="${layer.stroke.width}">`
			);
			icon = icon.replace('</svg>',`</g></svg>`);
		}

		if(layer.blur)
		{
			icon = icon.replace(/(<svg[^>]+)>/,`$1>
				<defs><filter id="hapiblur"><feGaussianBlur result="blur" stdDeviation="${5*layer.blur/100}" /></filter></defs>
				<g filter="url(#hapiblur)">`
			);
			icon = icon.replace('</svg>',`</g></svg>`);
		}

		icon = 'data:image/svg+xml;base64,' + btoa(icon)

		const anchor = layer.anchor
			? [layer.anchor[0],layer.anchor[1]]
			: [_symbole.center[0],_symbole.center[1]]
		if(styleDef.anchor)
		{
			anchor[0] = anchor[0] + (styleDef.anchor[0] - 0.5)/ratio;
			anchor[1] = anchor[1] + (styleDef.anchor[1] - 0.5)/ratio;
		}

		__style.push(new Style({
			zIndex: styleDef.zIndex,
			image: new Icon({
				anchor:anchor,
				color: layer.color || '#fff',
				opacity: layer.opacity || 1,
				imgSize:[iconSize,iconSize],
				size:[iconSize,iconSize],
				scale: 1,
				src: icon,
			})
		}));
	}

	return __style;
};

export  default Symbole;